module.exports = __webpack_public_path__ + "media/images/mother-day/motherday-template-uz-30d7ec349cb92afe3be22681957ad107.png";